import styled, { css } from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import { AlertStatusName, IGNORED } from '@rsos/constants/alertStatuses';

export const CHAT_HEADER_HEIGHT = 60;
export const PRIVILEGED_CHAT_MARGIN = 10;

const grayedOut = css`
  opacity: 0.4;
`;

interface AlertChatBoxContainerProps {
  isChatBoxVisible: boolean;
}

export const AlertChatBoxContainer = styled(
  Box,
).attrs<AlertChatBoxContainerProps>(({ isChatBoxVisible }) => ({
  width: '100%',
  grow: true,
  borderRadius: '5px',
  borderWidth: '1px',
  height: isChatBoxVisible ? 'auto' : '0',
}))<AlertChatBoxContainerProps>``;

interface TalkJSContainerProps {
  chatBoxHeight: string;
  alertActionsHeight: string;
  isChatBoxVisible: boolean;
}

export const TalkJSContainer = styled(Box).attrs<TalkJSContainerProps>(
  ({ chatBoxHeight, alertActionsHeight, isChatBoxVisible }) => ({
    flex: '1 1 auto',
    width: '100%',
    height: isChatBoxVisible
      ? `calc(${chatBoxHeight} - ${alertActionsHeight} - ${CHAT_HEADER_HEIGHT}px)`
      : '0',
    backgroundColor: 'background',
    borderRadius: '5px',
  }),
)<TalkJSContainerProps>``;

interface AlertActionsProps {
  alertStatus?: AlertStatusName;
  showRemoveAlert?: boolean;
}

export const AlertActions = styled(Box).attrs({
  flex: '0 0 auto',
  height: 'auto',
  backgroundColor: 'background',
})<AlertActionsProps>`
  ${({ alertStatus, showRemoveAlert }) =>
    alertStatus === IGNORED && !showRemoveAlert && grayedOut};
`;
